import { isSecondaryHospital } from '@/utils'

/**
 * 住院医生路由
 */
var basePath = 'emr'
const emrRouters = [
  {
    path: `${basePath}/patient-list`,
    name: `${basePath}/patient-list`,
    meta: {
      title: '电子病历',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/emr/patient-list.vue'], resolve)
  },
  {
    path: `${basePath}/emr-reader/:inpatient_record_id/:patient_id`,
    name: `${basePath}/emr-reader`,
    meta: {
      title: '电子病历查阅',
      requiresAuth: true,
      nav: {
        title: '电子病历',
        path: '/default/emr/patient-list',
        children: null
      }
    },
    component: resolve => isSecondaryHospital() ? require(['../views/page/emr/emr-reader-l2.vue'], resolve) : require(['../views/page/emr/emr-reader.vue'], resolve)
  },
  {
    path: `${basePath}/medical-record-search`,
    name: `${basePath}/medical-record-search`,
    meta: {
      title: '病历检索',
      requiresAuth: true,
      keepAlive: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/emr/medical-record-search.vue'], resolve)
  }
]

export default emrRouters
